/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Nameplaceholder1Inputs */

const he_profile_nameplaceholder1 = /** @type {(inputs: Profile_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזינו את שמכם`)
};

const en_profile_nameplaceholder1 = /** @type {(inputs: Profile_Nameplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your name`)
};

/**
* | output |
* | --- |
* | "Enter your name" |
*
* @param {Profile_Nameplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_nameplaceholder1 = /** @type {((inputs?: Profile_Nameplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Nameplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_nameplaceholder1(inputs)
	return en_profile_nameplaceholder1(inputs)
});
export { profile_nameplaceholder1 as "profile_namePlaceholder" }